import React, { FC, useCallback, useEffect, useMemo, useRef, useState } from "react"
import { observer } from "mobx-react-lite"
import { Appearance, TextInput, ViewStyle, ImageStyle, Platform, TouchableOpacity, Dimensions } from "react-native"
import { Button, Screen, Text, FormProps, FormControl, useAutoFeederPond, PickerActionsheet } from "../../../../components"
// import { useStores } from "../../models"
import { color } from "../../../../theme"
import { CompositeScreenProps } from "@react-navigation/native"
import { Toast, View, useDisclose } from "native-base"
import { SafeAreaView } from "react-native-safe-area-context"
import { TxKeyPath, translate } from "../../../../i18n"
import FontAwesomeIcons from "react-native-vector-icons/FontAwesome5"
import { Field, Formik, FormikProps, FormikValues } from "formik"
import _ from 'lodash'
import { goBack, navigate } from "../../../../navigators"
import { useStores } from "../../../../models"
import moment from "moment"
import { AutoFeederPond } from "../../../../database"
import WifiManager from 'react-native-wifi-reborn';

const ROOT: ViewStyle = {
  backgroundColor: color.palette.white,
  flex: 1
}

const DOUBLE_BUTTON: ViewStyle = {
  width: "48%"
}

const FORM_DROPDOWN: ViewStyle = {
  marginBottom: 4,
}

const LEFT_ELEMENT: ImageStyle = {
  marginLeft: 9
}

const CONNECT_BUTTON: ViewStyle = {
  width: "100%",
  marginTop: 22
}

const PICKER_CONTAINER: ViewStyle = {
  borderWidth: 1,
  borderColor: color.palette.gray200,
  borderRadius: 5,
  paddingHorizontal: 5,
  paddingVertical: 13,
  flexDirection: "row",
  alignItems: "center"
}

interface WifiCardProps extends FormProps {
  initialValues?: { ssid?: string, password?: string },
  wifiList?: any
}

const WifiCard = observer(function WifiCard(props: WifiCardProps) {
  const { initialValues = {}, colorScheme = "light" || Appearance.getColorScheme(), onSubmit,  innerRef, wifiList, ...rest  } = props
  const { isOpen, onOpen, onClose } = useDisclose()

  const input = {
    ssid: useRef<TextInput>(),
    password: useRef<TextInput>()
  }

  const nextInput = {
    ssid: () => input.password.current && input.password.current.focus(),
  }

  const renderItemPicker = (item) => {
    return <View minHeight="44px" flexDirection="row" alignItems="center" px="16px">
      <Text text={item.item ? item.item.SSID : "-"} preset="title4" color={color.palette.gray800} />
    </View>
  }

  return (
    <Formik
      initialValues={{ ...initialValues }}
      onSubmit={onSubmit}
      innerRef={innerRef}
      {...rest}
    >
    {({ isValid, handleSubmit, values, initialValues }) => (
      <>
        <Field name="ssid">
          {({ field, form: { setFieldValue, setFieldTouched }, meta }) => {
            console.log(field, 'field')
            return (
            <FormControl
            isInvalid={meta.touched && !!meta.error}
            labelTx={`autoFeederPondCreateWizardScreen.${_.camelCase(field.name)}` as TxKeyPath}
            colorScheme={colorScheme}
            inputProps={{
              testID: `jala:id/${field.name}-input`,
              ref: input[field.name],
              autoCapitalize: "none",
              autoCorrect: false,
              defaultValue: meta.initialValue,
            }}
            errorMessage={meta.error}
            style={FORM_DROPDOWN}
              // {...formControlProps}
            >
              <TouchableOpacity style={PICKER_CONTAINER} onPress={onOpen}>
                <FontAwesomeIcons name="wifi" size={18} color={color.palette.gray500} style={LEFT_ELEMENT} />
                <Text text={field.value || "SSID Wifi"} color={field.value ? color.palette.gray800 : color.palette.gray500} preset={field.value ? "title4" : "body3"} ml="14px" />
              </TouchableOpacity>
              <PickerActionsheet
                colorScheme="light"
                isOpen={isOpen}
                onClose={onClose}
                data={wifiList}
                titleTx="picker.choose"
                withoutSearch
                onPressItem={(item) => async () => {
                  await setFieldValue(field.name, item.SSID)
                  await setFieldTouched(field.name)
                }}
                renderItem={renderItemPicker}
                flatListProps={{
                  keyExtractor: (item, index) => `${item.id || index}`,
                  estimatedItemSize: 44,
                }}
                // eslint-disable-next-line react-native/no-inline-styles
                actionsheetStyle={{
                  minHeight: "40%",
                  ...(Platform.OS === 'web' ? { maxHeight: Dimensions.get("window").height * 2.5 } : {}),
                }}
              />
            </FormControl>
          )}}
        </Field>
        <Field name="password">
          {({ field, form: { handleChange, handleBlur }, meta }) => (
            <FormControl
              isInvalid={meta.touched && !!meta.error}
              labelTx={`autoFeederPondCreateWizardScreen.${_.camelCase(field.name)}` as TxKeyPath}
              colorScheme={colorScheme}
              inputProps={{
                testID: `jala:id/${field.name}-input`,
                ref: input[field.name],
                autoCapitalize: "none",
                autoCorrect: false,
                type: "password",
                autoComplete: "password",
                textContentType: "password",
                returnKeyType: nextInput[field.name] ? "next" : "go",
                onSubmitEditing: () => nextInput[field.name] ? nextInput[field.name]() : (isValid && handleSubmit()),
                placeholderTx: `autoFeederPondCreateWizardScreen.${_.camelCase(field.name)}` as TxKeyPath,
                defaultValue: meta.initialValue,
                onChangeText: handleChange(field.name),
                onBlur: handleBlur(field.name)
              }}
              errorMessage={meta.error}
              style={FORM_DROPDOWN}
            />
          )}
        </Field>
      </>
    )}
    </Formik>
  )
})

export const WizardConectionWifiSetupScreen: FC<{ colorScheme?: "light" | "dark" } & CompositeScreenProps<any, any>> = observer(function WizardConectionWifiSetupScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme() } = props
  const { autoFeederPond: model, setAutoFeederPond: setModel } = useAutoFeederPond()
  const [ wifiConnecting, setWifiConnecting ] = useState<boolean>(false)
  const [wifiList, setWifiList] = useState([]);

  const originalState = model && model.getAttributes().state;
  const state = useMemo(() => (
    originalState ? model.getAttribute('state') : undefined
  ), [model, originalState])

  const modelForm = useRef<FormikProps<FormikValues>>()
  const modelFormRef = useCallback((node) => {
    modelForm.current = node;
    // if (modelForm.current) setIsError(!(modelForm.current.isValid))
  }, [])

  const {
    appStore: { farmStore: { pondStore: { autoFeederPond } } },
    autoFeederPondStore: modelStore
  } = useStores()

  useEffect(() => modelStore.init(), [modelStore])

  useEffect(() => {
    if(Platform.OS === 'android') {
      const fetchWifiList = async () => {
        try {
          const wifiList = await WifiManager.loadWifiList();
          setWifiList(wifiList);
        } catch (error) {
          console.log('Error fetching Wi-Fi list:', error);
        }
      };

      fetchWifiList();
    }
  }, []);


  useEffect(() => {
    if (!model) setModel(AutoFeederPond.hydrate({ ...autoFeederPond }))
  }, [autoFeederPond, model, setModel])

  const onWifiValueChange = useCallback(async (value) => {
    console.log(value, 'wifi form')
    model.ip = null
    setWifiConnecting(true)
    try {
      model.ip = await model.writeUntilResponse(`;12;${value.ssid};${value.password}#`, 15000);
    } catch (e) {
      Toast.show({ title: e.message })
      if (e?.code === 'NOT_CURRENTLY_CONNECTED') {
        await model.disconnect().catch((e))
        setModel(model)
        goBack('Home.Stack')
      }
    } finally {
      setWifiConnecting(false)
    }
    await modelStore.update(model, { state: {
      ...state,
      updatedAt: moment.utc().format('YYYY-MM-DD HH:mm:ss'),
      ip: model.ip,
      ssidSetting: value || null
    } })
    setModel(model)
    await modelStore.set('needRefresh', true);
    if (model.ip) navigate('Home.Stack', 'Home.AutoFeederPond.Wizard.Mode.Setup')
  }, [model, modelStore, setModel, state])

  const handleSubmit = useCallback((event) => {
    if (modelForm.current) modelForm.current.handleSubmit(event)
  }, [])

  const handleNext = useCallback(() => {
    navigate('Home.Stack', 'Home.AutoFeederPond.Wizard.Mode.Setup')
  }, [])

  const handleBack = useCallback(() => {
    goBack('Home.Stack')
  }, [])

  return (
    <Screen style={ROOT} preset="scroll" colorScheme={colorScheme} hideOnBlurred>
      <SafeAreaView />
      <View px="16px">
        <Text preset="body2" text={`2/4: ${translate("autoFeederPondCreateWizardScreen.connectionSetup")}`} color={color.palette.gray800} mb="8px" />
        <View height="3px" backgroundColor={color.palette.gray300} borderRadius="5px">
          <View height="3px" backgroundColor={color.primary} width="50%" borderRadius="5px" />
        </View>
        <Text preset="title3" tx="autoFeederPondCreateWizardScreen.connectAstoWifi" color={color.palette.gray900} mt="30px" />
        <Text preset="body2" tx="autoFeederPondCreateWizardScreen.connectAstoWifiSubtitle" color={color.palette.gray700} mt="4px" mb="32px" />
        <WifiCard wifiList={wifiList} onSubmit={onWifiValueChange} innerRef={modelFormRef} />
        <Button
          tx="autoFeederPondCreateWizardScreen.connect"
          colorScheme={colorScheme}
          style={CONNECT_BUTTON}
          onPress={handleSubmit}
          disabled={wifiConnecting}
        />
      </View>
      <View flex={1} />
      <View
        borderTopWidth={1}
        borderColor={color.palette.gray400}
        backgroundColor={color.palette.white}
        padding="16px"
      >
        <View
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Button
            testID="jala:id/left-button"
            tx="common.back"
            colorScheme={colorScheme}
            // loading={loading}
            onPress={handleBack}
            style={DOUBLE_BUTTON}
            preset="outline"
          />
          <Button
            testID="jala:id/right-button"
            tx="homeScreen.tooltipSkip"
            colorScheme={colorScheme}
            // disabled={isError}
            // loading={loading}
            onPress={handleNext}
            style={DOUBLE_BUTTON}
          />
        </View>
      </View>
    </Screen>
  )
})
